import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-job-detail',
  templateUrl: './page-job-detail.component.html',
  styleUrls: ['./page-job-detail.component.css'],
  standalone: false,
})
export class PageJobDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
